import React, { useState } from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import styles from "./styles";
import { Box, Step, Button, StepLabel, Stepper } from "@mui/material/";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import StepContent from "./StepContent";
import { documentation } from "./content";

const steps = [
    {
        id: "problems",
        label: i18next.t("problems"),
    },
    {
        id: "device-os",
        label: i18next.t("device-os"),
    },
];

export default function HorizontalStepper() {
    const [activeStep, setActiveStep] = useState(0);
    const [codeAccum, setCodeAccum] = useState("");
    const { t } = useTranslation();
    const classes = makeStyles(styles)();

    const handleNext = (stepCode) => () => {
        let newAccum = "";
        // if last step, redirect to documentation
        if (codeAccum.indexOf(stepCode) === -1) {
            newAccum = `${codeAccum}${codeAccum === "" ? "" : "+"}${stepCode}`;
        } else newAccum = codeAccum;

        if (activeStep + 1 === steps.length) {
            window.open(documentation[newAccum], "_blank");
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setCodeAccum(newAccum);
        }
    };

    const handleBack = () => {
        setActiveStep(0);
        setCodeAccum("");
    };

    return (
        <Box className={classes.wrapStepper}>
            <Stepper activeStep={activeStep}>
                {steps.map((step, index) => {
                    return (
                        <Step key={step.id}>
                            <StepLabel>{step.label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            <>
                <StepContent
                    id={steps[activeStep].id}
                    handleNext={handleNext}
                />
                <Box className={classes.wrapBackBtn}>
                    <Button
                        color="inherit"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                        startIcon={<ArrowBackIcon />}
                    >
                        {t("back")}
                    </Button>
                </Box>
            </>
        </Box>
    );
}
